import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import FirebaseApp from './FirebaseApp'
// import moment from 'moment'
import moment from 'moment-timezone';

Vue.config.productionTip = false
Vue.use(FirebaseApp)

//  set up filters
Vue.filter('prettyPrice', (price) => {
  if(price) {
    return price.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }
  return "";
})
Vue.filter('prettyPriceFromInt', (price) => {
  if(price) {
    return (price/100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }
  return "";
})
Vue.filter('prettyDateShortTz', (timestamp) => {
  if(timestamp) {
    return moment.unix(timestamp).tz('America/Chicago').format("M/D/YY");
  }
  return "";
})
Vue.filter('prettyDateTimeShortTz', (timestamp) => {
  if(timestamp) {
    return moment.unix(timestamp).tz('America/Chicago').format("M/D/YY h:mma");
  }
  return "";
})
Vue.filter('prettyDate', (timestamp) => {
  if(timestamp) {
    return moment.unix(timestamp).format("MMM Do, YYYY");
  }
  return "";
})
Vue.filter('prettyDateShort', (timestamp) => {
  if(timestamp) {
    return moment.unix(timestamp).format("M/D/YY");
  }
  return "";
})
Vue.filter('prettyDateTime', (timestamp) => {
  if(timestamp) {
    return moment.unix(timestamp).format("MMM Do, YYYY, h:mm:ssa Z");
  }
  return "";
})
Vue.filter('prettyDateTimeShort', (datetime) => {
  if(datetime) {
    return moment(datetime).format("M/D/YY h:mma");
  }
  return "";
})
Vue.filter('prettyDateDayMo', (timestamp) => {
  if(timestamp) {
    return moment.unix(timestamp).format("M/D");
  }
  return "";
})
Vue.filter('prettyDateMoName', (timestamp) => {
  if(timestamp) {
    return moment.unix(timestamp).format("MMM");
  }
  return "";
})
Vue.filter('prettyTimeFromDT', (datetime) => {
  // datetime format like "2025-01-10 09:39:54"
  if(datetime) {
    return moment.tz(datetime, 'America/Chicago').format("h:mma");
  }
  return "";
})
Vue.filter('prettyDateShortFromDT', (datetime) => {
  // datetime format like "2025-01-10 09:39:54"
  if(datetime) {
    return moment.tz(datetime, 'America/Chicago').format("M/D/YY");
  }
  return "";
})
Vue.filter('formatDate', (datecode) => {
  if(datecode) {
    // format datecode like 20230906
    let year = datecode.slice(0,4);
    let month = datecode.slice(4,6).replace(/0(.)/,'$1');
    let day = datecode.slice(6).replace(/0(.)/,'$1');
    return `${month}/${day}/${year}`
  }
  return "";
})
Vue.filter('limitStringLength', (str,length) => {
  if(str && length) {
    if(str.length > length) {
      return str.slice(0,length) + '...';
    }
    return str;
  }
  return "";
})
Vue.filter('formatNumber', (value) => {
  const amount = Number(value);
  if(!Number.isFinite(amount)) {
    return '0';
  }
  return Math.round(amount).toLocaleString('en-US');
})
Vue.filter('formatCurrency', (value) => {
  const amount = Number(value) || 0;

  if(Math.abs(amount) >= 1000000) {
    const roundedMillions = (Math.abs(amount) / 1000000).toFixed(2);
    return `${amount < 0 ? '-' : ''}$${roundedMillions}M`;
  }

  if(Math.abs(amount) >= 1000) {
    const roundedThousands = Math.round(Math.abs(amount) / 1000);
    return `${amount < 0 ? '-' : ''}$${roundedThousands}k`;
  }

  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
})
Vue.filter('formatCurrencyFull', (value) => {
  const amount = Number(value) || 0;
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
})
// Vue.filter('prettyRouteName', (routename) => {
//   if(routename) {
//     let str = `${routename}`;
//     str = str.replace('Encounter_tp','');
//     return str.toLowerCase();
//   }
//   return "";
// })

// find user before creating app, if they are logged in when page refreshed
// wrap Vue app in firebase onAuthStateChanged to check for user before creating app
Vue.auth.onAuthStateChanged((user) => {
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    created () {
      if(user) {
        store.dispatch('updateUser', user)
      }
    }
  })
})
